import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Container, CardWrapper, NoData } from '../ChallengeDashboardV2/CompletedChallenge/styles';
import _ from 'lodash';
import Waiting from '../Waiting/index';
import { connect } from 'react-redux';
import { setSelectedYear } from '../../redux/actions/companyDashboard/index';
import {getAdminCompletedChallenges} from '../../redux/actions/challengeActions/index'
import { withTranslation } from 'react-i18next';
import { toggleDummyChallenges } from "../../redux/actions";
import CompletechallengeCard from '../CompanyChallengesAdminUpdated/completeChallenge'

class CompletedChallengeV2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      onHover: null
    };
  }

  componentDidMount() {
    const { getAdminCompletedChallenges, selectedYearInfo, companyId } = this.props;
    getAdminCompletedChallenges(selectedYearInfo, companyId)
    // this.props.history.push(`/company/challenges/completed`)
  }

  onEnterHover=(id)=>{
    this.setState({
      onHover: id
    })
  }

  onLeaveMouse=()=>{
    this.setState({
      onHover: -1
    })
  }

  challengeRedirect = (id) => {
    this.props.history.push(`/company/challenges/completed/${id}`)
  };

  updateDropdown = (year) => {
    const { setSelectedYear, getAdminCompletedChallenges, companyId } = this.props;
    setSelectedYear(year);
    getAdminCompletedChallenges(year, companyId);
  };


  render() {
    const { challengesData, t, history } = this.props;
    if (!challengesData || _.isNull(challengesData) || _.isUndefined(challengesData)) {
      return <Waiting />
    }
    let adminChallengesData = challengesData.filter((obj) => obj.is_user_challenge === 0)
    return (
      <Container pagePadding>
        <div className="mainContainer">
          {adminChallengesData && adminChallengesData.length > 0 ?
            <CardWrapper style={{gap:"20px 24px"}}>
              {adminChallengesData && adminChallengesData.length > 0 && adminChallengesData.map((challenge, index) => (
                <CompletechallengeCard
                  challenge={challenge}
                  history={history}
                  key={index}
                  toggleDummyChallenges={toggleDummyChallenges}
                  margin={index}
                  adminChallenge={'1'}
                  onEnterMouse={this.onEnterHover}
                  onLeaveMouse={this.onLeaveMouse}
                  onHover={this.state.onHover}
                />
              ))}
            </CardWrapper> : <NoData>{t("No Data Present")}</NoData>}
        </div>
      </Container>
    );
  }
}

CompletedChallengeV2.propTypes = {
  challengesData: PropTypes.array,
  history: PropTypes.object.isRequired,
  yearList: PropTypes.array,
  selectedYearInfo: PropTypes.number,
  setSelectedYear: PropTypes.func,
  getAdminCompletedChallenges: PropTypes.func,
  t: PropTypes.func,
  companyId: PropTypes.number
};

const mapStateToProps = (state) => ({
  activeTab: state.challenges.activeTab,
  isLoading: state.challenges.isLoading,
  challengesData: state.challenges.response,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedYear: (year) => dispatch(setSelectedYear(year)),
  getAdminCompletedChallenges: (year, companyId) => dispatch(getAdminCompletedChallenges(year, companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CompletedChallengeV2));